window.GoogleReviews = phrase => {
	return {
		val: phrase,
	};
};
